import Link from 'next/link'
import { _slugify } from '../helpers/utils'

function BlogCategoriesBlock({ post, categories }) {
    return post.categories.map((id, index) => (
        <span key={id}>
            <Link href={`/blog/category/${_slugify(categories[id])}`}>
                <a className="hover:underline">{categories[id]}</a>
            </Link>
            {index < post.categories.length - 1 && <span> / </span>}
        </span>
    ))
}

export default BlogCategoriesBlock
